export default __webpack_public_path__ + "static/media/Gioithieu_thumbnail_4.70cb8527.png";